import { formatPayloadToClientObject } from './form'

/**
 * Builds the orders payload when goal-item fetch failed.
 * Falls back to list prices (no optimistic discounts) and re-sums
 * all_enrollment from merged goal_items so modification flows that
 * preserve delivered rows aren't undercounted.
 */
export const buildFallbackOrdersPayload = (
    payload: Parameters<typeof formatPayloadToClientObject>[0]
) => {
    const result = formatPayloadToClientObject(payload)
    const allEnrollment = (
        (result?.goal_items as { price?: string | number }[] | undefined) || []
    ).reduce(
        (sum, item) => sum + (Number(item.price) || 0),
        0
    )
    return { ...result, all_enrollment: allEnrollment }
}
